import { Box, MantineProvider } from "@mantine/core";
import type { BingoGame } from "bingo/types/bingo-game.model";

export function BingoScreenLayout({
  theme,
  children,
}: {
  theme: BingoGame;
  children: React.ReactNode;
}) {
  const backgroundSize = "1540px 220px"; // hardcode

  return (
    <Box
      className="h-screen w-screen overflow-hidden bg-cover bg-no-repeat flex justify-center items-center"
      sx={{
        background: "",
        color: "white",
        // fontFamily: "VirageCorporate-Regular, sans-serif", // Changed to Virage
        backgroundImage: `url(${theme.bingoTemplateSnapshot.images.screenBackgroundSize1})`,
        backgroundSize,
      }}
    >
      <MantineProvider
        theme={{
          fontFamily: "VirageCorporate-Regular, sans-serif",
          headings: {
            fontFamily: "VirageCorporate-Regular, sans-serif",
          },
        }}
      >
        {children}
      </MantineProvider>
    </Box>
  );
}
